export default __webpack_public_path__ + "static/media/oa_3.daf9ea56.mp3";